import { tViews } from "../../../../../../../utils/table";
const getColumns = ({ openTableSettings }) => {
    return [
        {
          id: "source_ip_col",
          prop: "source_ip",
          get name() { return tViews('usageADTopClientTable.column_label.clientIP')},
          sortable: true,
          size: 500
        },
        { 
          id: "display_usage_col",
          prop: "display_usage",
          get name() { return tViews('usageADTopClientTable.column_label.usage')},
          sortable: true,
          size: 500
        },
        {
          id: "actions_col",
          prop: "actions",
          name: "Actions",
          hiddenText: "Actions",
          disableToggle: true,
          sortable: false,
          headerSlot: false,
          pin: "colPinEnd",
          size: 70,
          columnTemplate: (createElement) => {
            return createElement("hbr-icon-button", {
              name: "gear-six-outlined",
              class: "hbr-css__table-cell-align-center gear-icon",
              "data-testid": "setting-ad-top-clients-table",
              onClick: (evt) => {
                evt.stopPropagation();
                openTableSettings();
              }
            });
          }
        }
    ]
}

export default getColumns;
